<template>
  <v-container fluid>
    <v-card elevation="1" class="mb-4">
      <v-card-title><h3>Service Confirmations</h3></v-card-title>
      <v-card-text>
        <service-conf></service-conf>
      </v-card-text>
    </v-card>

    <v-card elevation="1" class="mb-4">
      <v-card-title><h3>6 Month Service Compliance</h3></v-card-title>
      <v-card-text>
        <service-comp :data="sixMo" :timeframe="6" v-on:saved="get6Mo"></service-comp>
      </v-card-text>
    </v-card>

    <v-card elevation="1" class="mb-4">
      <v-card-title><h3>12 Month Service Compliance</h3></v-card-title>
        <service-comp :data="twelveMo" :timeframe="12" v-on:saved="get12Mo"></service-comp>
      <v-card-text>
        
      </v-card-text>
    </v-card>
    
    <v-card elevation="1" class="mb-4">
      <v-card-title><h3>18 Month Service Compliance</h3></v-card-title>
      <v-card-text>
        <service-comp :data="eighteenMo" :timeframe="18" v-on:saved="get18Mo"></service-comp>
      </v-card-text>
    </v-card>

    <v-card elevation="1" class="mb-4">
      <v-card-title><h3>24 Month Service Compliance</h3></v-card-title>
      <v-card-text>
        <service-comp :data="twentyfourMo" :timeframe="24" v-on:saved="get24Mo"></service-comp>
      </v-card-text>
    </v-card>

    <v-card elevation="1" class="mb-4" v-if="!isFacilitator">
      <v-card-title><h3>Proof of Payment</h3></v-card-title>
      <v-card-text>
        <pop></pop>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import appConfig from '@src/app.config'
import ServiceConfirmationTableVue from './ServiceConfirmationTable.vue';
import ServiceComplianceTableVue from '../ServiceCompliance/ServiceComplianceTable.vue';
import {mapGetters, mapActions} from 'vuex'
import { authComputed } from '@state/helpers'
import ProofOfPaymentTableVue from '../ProofOfPayment/ProofOfPaymentTable.vue';
const moduleNameSpace = 'serviceCompliance'
export default {
  name: 'UserService',
  data(){
    return {

    }
  },
  created(){
    this.get6Mo()
    this.get12Mo()
    this.get18Mo()
    this.get24Mo()
  },
  methods: {
    ...mapActions(moduleNameSpace, ['get6Mo', 'get12Mo', 'get18Mo', 'get24Mo'])
  },
  computed: {
    ...authComputed, 
    ...mapGetters(moduleNameSpace, ['sixMo', 'twelveMo', 'eighteenMo', 'twentyfourMo'])
  },
  components: {
    'service-conf' : ServiceConfirmationTableVue,
    'service-comp' : ServiceComplianceTableVue,
    'pop' : ProofOfPaymentTableVue
  }
}
</script>
